// @flow

import * as React from 'react';
import {allAdminRolesProps} from './AdminRoleDescriptions';
import {allConnectRoleProps} from './ConnectRoleDescriptions';
import {allCorporateCardRoleProps} from './CorporateCardRoleDescriptions';
import {allDeveloperRoleProps} from './DeveloperRoleDescriptions';
import {allPaymentRoleProps} from './PaymentRoleDescriptions';
import {RoleDescriptionsContainer} from './RoleDescription';
import {allSupportRoleProps} from './SupportRoleDescriptions';
import {allTaxRoleProps} from './TaxRoleDescriptions';
import {allViewOnlyRoleProps} from './ViewOnlyRoleDescriptions';

const GroupDescriptionMap = {
  admin: <RoleDescriptionsContainer roleDescriptions={allAdminRolesProps} />,
  connect: <RoleDescriptionsContainer roleDescriptions={allConnectRoleProps} />,
  corporateCard: (
    <RoleDescriptionsContainer roleDescriptions={allCorporateCardRoleProps} />
  ),
  developer: (
    <RoleDescriptionsContainer roleDescriptions={allDeveloperRoleProps} />
  ),
  payment: <RoleDescriptionsContainer roleDescriptions={allPaymentRoleProps} />,
  support: <RoleDescriptionsContainer roleDescriptions={allSupportRoleProps} />,
  tax: <RoleDescriptionsContainer roleDescriptions={allTaxRoleProps} />,
  viewOnly: (
    <RoleDescriptionsContainer roleDescriptions={allViewOnlyRoleProps} />
  ),
};

type RoleGroupDescriptionProps = {|
  groupName: string,
|};

export const RoleGroupDescription = ({
  groupName,
}: RoleGroupDescriptionProps) => {
  return GroupDescriptionMap[groupName];
};
